module.exports = __webpack_public_path__ + "img/picture_yctgl.f1a02e1c.png";